import * as React from 'react'
import { View, Text } from 'react-native'
import styled from '@theme/styled-components'

import useI18n from '@i18n/useI18n'

import Icon from '@components/icon/Icons'
import theme from '@theme/Theme'

export const DEFAULT_SIZE = 32
export const LARGE_SIZE = 56

export const COLORS = {
  ABANDONNEE: { default: theme.colors.abandoned, light: theme.colors.abandonedLight },
  CLOTUREE_PRESTATAIRE: { default: theme.colors.closed, light: theme.colors.closedLight },
  DEVIS_ENVOYE: { default: theme.colors.quote, light: theme.colors.quoteLight },
  EN_ATTENTE_DE_DEVIS: { default: theme.colors.waiting, light: theme.colors.waitingLight },
  EN_ATTENTE_DE_PRISE_EN_CHARGE: { default: theme.colors.waiting, light: theme.colors.waitingLight },
  EN_PAUSE: { default: theme.colors.abandoned, light: theme.colors.abandonedLight },
  EN_ATTENTE_DE_VALIDATION: { default: theme.colors.waiting, light: theme.colors.waitingLight },
  EN_COURS_DE_TRAITEMENT: { default: theme.colors.treating, light: theme.colors.treatingLight },
  CLOTUREE_VIPARIS: { default: theme.colors.closed, light: theme.colors.closedLight },
  REFUS_PRESTATAIRE: { default: theme.colors.waiting, light: theme.colors.waitingLight },
  FERMEE: { default: theme.colors.abandoned, light: theme.colors.abandonedLight },
  VALIDEE: { default: theme.colors.waiting, light: theme.colors.waitingLight },
}

export type IncidentTypeEnum = Exclude<
  Exclude<EtatWorkflowIncidentEnum, EtatWorkflowIncidentEnum.FERMEE>,
  EtatWorkflowIncidentEnum.VALIDEE
>

export const ICONS: { [key in IncidentTypeEnum]: IconName } = {
  ABANDONNEE: 'incident_minus',
  CLOTUREE_PRESTATAIRE: 'incident_key',
  DEVIS_ENVOYE: 'incident_right-arrow',
  EN_ATTENTE_DE_DEVIS: 'incident_euro',
  EN_ATTENTE_DE_PRISE_EN_CHARGE: 'incident_clock',
  EN_PAUSE: 'incident_clock',
  EN_ATTENTE_DE_VALIDATION: 'incident_done',
  EN_COURS_DE_TRAITEMENT: 'incident_key',
  CLOTUREE_VIPARIS: 'incident_done',
  REFUS_PRESTATAIRE: 'incident_cross',
}

interface Props {
  incidentStatus: EtatWorkflowIncidentEnum
  size?: 'default' | 'large'
}

const IncidentStatus = ({ incidentStatus, size = 'default' }: Props) => {
  const i18n = useI18n()
  return (
    <Container color={COLORS[incidentStatus].light} size={size}>
      <Icon
        name={ICONS[incidentStatus as IncidentTypeEnum]}
        size={size === 'large' ? 24 : 16}
        color={COLORS[incidentStatus].default}
      />
      <Label size={size}>{i18n.t(`incidentStatus.${incidentStatus}`)}</Label>
    </Container>
  )
}

export default IncidentStatus

const Container = styled(View)<{ color: string; size: 'default' | 'large' }>`
  height: ${(props) => (props.size === 'large' ? LARGE_SIZE : DEFAULT_SIZE)}px;
  border-radius: 8px;
  background-color: ${(props) => props.color};
  padding: 4px 16px;
  flex-direction: row;
  align-items: center;
`
const Label = styled(Text)<{ size: 'default' | 'large' }>`
  ${(props) => props.theme.fonts.Caption1};
  ${(props) => props.size === 'large' && 'font-size: 16px;'}
  margin-left: 14px;
`
